import React from 'react';
import { Container, Box, Typography } from "@mui/material";

const Verification = () => {

    return (
        <Container>
            <Box sx={{ padding: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Verification
                </Typography>
            </Box>
        </Container>
    );
};

export default Verification;
